import React from 'react';
import ResourceTypeIcon from './ResourceTypeIcon';
import type { Category, ResourceHubResource, ResourceType } from '@dr-pam/common-components/Models/NdcResourceHub';
import { isArticle, isResource } from '@dr-pam/common-components/Models/NdcResourceHub';
import Button from '@dr-pam/common-components/Components/Form/Button';

export type ResourceListProps = {
	className?: string;
	resourceTypes: ResourceType[];
	categories: Category[];
	resources: ResourceHubResource[];
};

export default function ResourceList(props: ResourceListProps) {
	const { className, resourceTypes, categories, resources } = props;

	const getCategoriesForResource = (resource: ResourceHubResource) => {
		return categories.filter((x) => resource.categoryIds.includes(x.id));
	};

	const sortedResources = resources.sort((a, b) => {
		return a.sortOrder - b.sortOrder;
	});

	return (
		<div className={`ResourceList ${className ?? ''}`}>
			{sortedResources.map((resource) => {
				const resourceType = resourceTypes.find((x) => x.id === resource.resourceTypeId);
				const categories = getCategoriesForResource(resource);

				let link = '#';
				if (isArticle(resource)) {
					link = `/article/${resource.id}`;
				} else if (isResource(resource)) {
					link = `/resource/${resource.id}`;
				}

				return (
					<a href={link} target="_blank" rel="noopener noreferrer" key={resource.id} className="resource">
						<ResourceTypeIcon name={resourceType?.name ?? ''} size="2.5em" />
						<span className="title">{resource.title}</span>
						<span className="type">{resourceType?.name ?? ''}</span>
						<span className="categories">
							{categories.map((x) => (
								<span key={x.id} className="category">
									{x.name}
								</span>
							))}
						</span>
						<Button className="small-button">View</Button>
					</a>
				);
			})}
		</div>
	);
}
